import { SelectOption } from "../models/common";
import {
  ChildrenTypes,
  Genders,
  HealthConcerns,
  HeightUnits,
  MaritalStatuses,
  QualityOfLifeTypes,
  WeightUnits,
} from "../models/users";

export const referralSources: string[] = [
  "friends_family",
  "search_engine",
  "news",
  "social_media",
  "ads",
  "another_website",
  "doctor",
  "lawyer",
  "financial_advisor",
  "accountant",
  "funeral_home",
  "other",
];
export const helpLinkSources = [
  {
    label: "Learning Center",
    url: "https://planwellguide.com/learn/",
  },
  {
    label: "Resources",
    url: "https://planwellguide.com/resources/",
  },
  {
    label: "FAQs",
    url: "https://planwellguide.com/frequently-asked-questions/",
  },
  {
    label: "Contact Us",
    url: "https://qa.planwellguide.com/contact",
  },
];

export const genderTypes: Genders[] = [
  "female",
  "male",
  "non_binary",
  "not_provided",
];
export const maritalStatuses: MaritalStatuses[] = [
  "married",
  "living_married",
  "widowed",
  "single",
  "divorced_separated",
  "divorced_remarried",
];
export const childrenTypes: ChildrenTypes[] = [
  "no",
  "yes_1",
  "yes_more_than_1",
];
export const qualitiesOfLife: QualityOfLifeTypes[] = [
  "excellent",
  "very_good",
  "good",
  "fair",
  "poor",
];
export const healthConcerns: HealthConcerns[] = [
  "significant",
  "minor",
  "none",
];
export const weightUnits: WeightUnits[] = ["lbs", "kgs"];
export const heightUnits: HeightUnits[] = ["inches", "cm"];
export const heightFtOptions: SelectOption[] = [
  {
    label: "3'",
    value: 3,
  },
  {
    label: "4'",
    value: 4,
  },
  {
    label: "5'",
    value: 5,
  },
  {
    label: "6'",
    value: 6,
  },
  {
    label: "7'",
    value: 7,
  },
];

export const heightInOptions: SelectOption[] = [
  {
    label: `0"`,
    value: 0,
  },
  {
    label: `1"`,
    value: 1,
  },
  {
    label: `2"`,
    value: 2,
  },
  {
    label: `3"`,
    value: 3,
  },
  {
    label: `4"`,
    value: 4,
  },
  {
    label: `5"`,
    value: 5,
  },
  {
    label: `6"`,
    value: 6,
  },
  {
    label: `7"`,
    value: 7,
  },
  {
    label: `8"`,
    value: 8,
  },
  {
    label: `9"`,
    value: 9,
  },
  {
    label: `10"`,
    value: 10,
  },
  {
    label: `11"`,
    value: 11,
  },
];

export const frequencyOptions: SelectOption[] = [
  {
    label: `Everyday`,
    value: 1,
  },
  {
    label: `Every Other Day`,
    value: 2,
  },
  {
    label: `Every three days`,
    value: 3,
  },
  {
    label: `Every four days`,
    value: 4,
  },
  {
    label: `Every five days`,
    value: 5,
  },
  {
    label: `Every Week`,
    value: 7,
  },
  {
    label: `Every 2 weeks`,
    value: 14,
  },
  {
    label: `Every month`,
    value: 31,
  },
];
